import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { updateVideo } from "store/actions/youtubeVideosAction";
import { addVideo } from "store/actions/youtubeVideosAction";

function AddYoutubeModel({ isOpen, toggle, data }) {
  const dispatch = useDispatch();
  const { addVideoLoader } = useSelector((state) => state.youtubeVideos);
  const [creds, setCreds] = useState({
    videoTitle: "",
    videoUrl: "",
  });

  const handleInputChange = (e) => {
    setCreds((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (data?.id) {
      dispatch(
        updateVideo(data.id, creds, () => {
          setCreds({
            videoTitle: "",
            videoUrl: "",
          });
          toggle();
        })
      );
    } else {
      dispatch(
        addVideo(creds, () => {
          setCreds({
            videoTitle: "",
            videoUrl: "",
          });
          toggle();
        })
      );
    }
  };

  useEffect(() => {
    if (data) {
      setCreds({
        videoTitle: data?.videoTitle,
        videoUrl: data?.videoUrl,
      });
    }
  }, [data]);

  return (
    <Modal toggle={toggle} isOpen={isOpen}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {data ? "Edit Youtube Video " : "Add Youtube Video"}
        </h5>
        <button
          aria-label="Close"
          className="close"
          type="button"
          onClick={toggle}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <ModalBody>
        <Row>
          <Form role="form" onSubmit={handleSubmit} className="w-100 px-4">
            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <Input
                  placeholder="Title"
                  className="w-100"
                  type="text"
                  value={creds.videoTitle}
                  name="videoTitle"
                  onChange={handleInputChange}
                  autoComplete="new-email"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <InputGroup className="input-group-alternative">
                <Input
                  placeholder="Embeded Url"
                  type="text"
                  value={creds.videoUrl}
                  name="videoUrl"
                  onChange={handleInputChange}
                />
              </InputGroup>
            </FormGroup>
            <Row className="justify-content-end">
              <Button
                color="danger"
                type="button"
                onClick={toggle}
                className="mt-2"
              >
                Close
              </Button>
              <Button color="primary" type="submit" className="mt-2">
                {addVideoLoader ? <Spinner size="sm" /> : "Save Changes"}
              </Button>
            </Row>
          </Form>
        </Row>
      </ModalBody>
    </Modal>
  );
}

export default AddYoutubeModel;
